import TotpSetup from "./TotpSetup";

export default TotpSetup;
